import { useEffect } from "react";
import {
  CoalitionProgressBar,
  SingleProductImg,
} from "../CoalitionComplements";
import {
  ExpiracyDetail,
  RedeemableLabel,
  privGtmKey,
  stylePrice,
} from "../../utils";
import { not_available_horizontal, gift_icon } from "../../pngs";
import { CoalitionCollapsible } from "../CoalitionCollapsible";
import {
  sendTag,
  event_properties_104_03,
  event_properties_104_04,
} from "../CoalitionGtm";
import "./../CoalitionCards/CardDetail.scss";

export const CoalitionCardRewardsDetail = ({ card }) => {
  const {
    id,
    balance,
    required_balance,
    available_to_redeem,
    image,
    title,
    description,
    terms_and_conditions,
    valid_until,
  } = card;
  const redeemable = balance >= required_balance || available_to_redeem >= 1;
  const balanceFixed = available_to_redeem
    ? available_to_redeem * required_balance + balance
    : balance;
  const balanceLabel = `Llevas ${stylePrice(balanceFixed)} de ${stylePrice(
    required_balance
  )}`;

  const gtm = localStorage.getItem(privGtmKey);
  useEffect(() => {
    if (gtm) {
      let payload = event_properties_104_03();
      payload.reward_id = id;
      payload.reward_progress = balanceLabel;
      sendTag(gtm, payload);
    }
  }, [gtm, id, balanceLabel]);
  const sendEvent = () => {
    let payload = event_properties_104_04();
    payload.reward_id = id;
    payload.reward_progress = balanceLabel;
    sendTag(gtm, payload);
  };

  return (
    <div className="card-detail">
      <div className="product-image">
        <SingleProductImg load={image} error={not_available_horizontal} />
      </div>
      <RedeemableLabel
        redeemable={redeemable}
        image={gift_icon}
        label={"¡Ya puedes cambiar tu recompensa!"}
      />
      <div className="title">{title}</div>
      <div className="description">{description}</div>
      <ExpiracyDetail expiracy={valid_until} />
      <div className="progress">
        <CoalitionProgressBar current={balanceFixed} max={required_balance} />
      </div>
      <div className="progress-text">
        <div dangerouslySetInnerHTML={{ __html: balanceLabel }} />
      </div>
      <div
        onClick={() => sendEvent()}
        onKeyPress={() => sendEvent()}
        role="button"
        tabIndex={0}
      >
        <CoalitionCollapsible terms={terms_and_conditions} />
      </div>
    </div>
  );
};
